// Translator notes: "before" + a noun phrase and Finnish "ennen" + a partitive (engine/src/rules/before-noun.ts,
// engine/src/passes/before-noun.ts). Each id is an engine note (`notes.add(text, id, args)`); `args` names its
// arguments in the order the strings take them. Collected by translator/notes.ts (import.meta.glob).
import { defineNotes } from '../note-defs';

export const notes = defineNotes({
  beforeNounTime: {
    args: ['word', 'hv'],
    fi: (a: string[]) =>
      `”Before ${a[0]}” on ajankohta, joten valyriaksi se on jälkiasema ${a[1]} ja genetiivi. Petersonin mukaan ajallinen ”ennen” on ${a[1]}.`,
    en: (a) => `“Before ${a[0]}” is a time, so in Valyrian it is the postposition ${a[1]} with the genitive. Peterson: temporal “before” is ${a[1]}.`,
  },
  beforeNounPlace: {
    args: ['word', 'hv'],
    fi: (a: string[]) =>
      `”Before ${a[0]}” on paikka tai joku, jonka edessä ollaan, joten valyriaksi se on ${a[1]} ’edessä’ ja genetiivi. Petersonin mukaan ${a[1]} on vain paikasta.`,
    en: (a) =>
      `“Before ${a[0]}” is a place, or someone one stands before, so in Valyrian it is ${a[1]} “in front of” with the genitive. Peterson: ${a[1]} is only about place.`,
  },
  beforeNounUnsure: {
    args: ['word', 'time', 'place'],
    fi: (a: string[]) =>
      `Sanakirjasta ei näe, onko ”before ${a[0]}” aikaa vai paikkaa. Käännös olettaa ajan: ${a[1]} ja genetiivi. Jos tarkoitat ’edessä’, sana on ${a[2]} (vaihtoehdoissa).`,
    en: (a) =>
      `The dictionary does not show whether “before ${a[0]}” is a time or a place. The translation assumes a time: ${a[1]} with the genitive. If you mean “in front of”, the word is ${a[2]} (in the alternatives).`,
  },
  beforeNounFi: {
    args: ['hv'],
    fi: (a: string[]) =>
      `”Ennen” ja partitiivi on ajankohta, joten valyriaksi se on jälkiasema ${a[0]} ja genetiivi. Petersonin mukaan ajallinen ”ennen” on ${a[0]}.`,
    en: (a) => `“Ennen” with the partitive is a time, so in Valyrian it is the postposition ${a[0]} with the genitive. Peterson: temporal “before” is ${a[0]}.`,
  },
});

declare module '../note-defs' {
  interface NoteIds extends Record<keyof typeof notes, true> {}
}
